import closeIcon from './close-icon.svg';
import rightArrow from './right-arrow.svg';
import downArrow from './down-arrow.svg';
import checLogo from './chec-logo.svg';

export default {
  closeIcon,
  rightArrow,
  downArrow,
  checLogo,
};
